<div class="modal-box add-order-subscription-modal" cdkDrag>
    <form id="frmAddForm" class="add-order-subscription-modal__form modal-form" [formGroup]="addForm" (ngSubmit)="onSubmit()">
        <div class="modal-header add-order-subscription-modal__header" cdkDragHandle>
            <div class="add-order-subscription-modal__headline modal-headline">
                <span class="add-order-subscription-modal__eyebrow modal-eyebrow">{{ 'ORDERS' | translate }}</span>
                <h4 class="modal-title add-order-subscription-modal__title modal-heading">{{ 'ADD_ORDER_TO_SUBSCRIPTION' | translate }}</h4>
            </div>
            <button type="button" class="add-order-subscription-modal__close modal-close" [attr.aria-label]="'CLOSE' | translate" (click)="activeModal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>

        <div class="modal-body add-order-subscription-modal__body">
            <div class="add-order-subscription-modal__sections modal-sections">
                <section class="add-order-subscription-modal__panel modal-panel">
                    <div class="add-order-subscription-modal__panel-header modal-panel-header">
                        <span class="add-order-subscription-modal__panel-eyebrow modal-panel-eyebrow">{{ 'ORDER_BUILDER' | translate }}</span>
                        <h5 class="add-order-subscription-modal__panel-title modal-panel-title">{{ 'SUBSCRIPTION_ITEMS' | translate }}</h5>
                        <p class="add-order-subscription-modal__helper modal-helper">{{ 'SET_THE_AMOUNT_FOR_ANY_PRODUCTS_YOU_WANT_INCLUDED_IN_THIS_ORDER' | translate }}</p>
                    </div>

                    <div *ngIf="products?.length; else noProducts" class="add-order-subscription-modal__list">
                        <div *ngFor="let product of products" class="add-order-subscription-modal__item-row">
                            <div class="add-order-subscription-modal__item-main">
                                <div class="add-order-subscription-modal__media" *ngIf="product.mediaSrc; else noMedia">
                                    <img [src]="product.mediaSrc" [alt]="product.name">
                                </div>
                                <ng-template #noMedia>
                                    <div class="add-order-subscription-modal__media add-order-subscription-modal__media--placeholder">
                                        <span>{{ 'NO_IMAGE' | translate }}</span>
                                    </div>
                                </ng-template>

                                <div class="add-order-subscription-modal__item-copy">
                                    <div class="add-order-subscription-modal__item-title">{{ product.name }}</div>
                                    <div class="add-order-subscription-modal__item-price">{{ 'UNIT_PRICE' | translate }}: {{ formatPrice(product.price) }}</div>
                                </div>
                            </div>

                            <div class="add-order-subscription-modal__field modal-field">
                                <label class="add-order-subscription-modal__label modal-label" [for]="'product-amount-' + product.id">{{ 'AMOUNT' | translate }}</label>
                                <div class="add-order-subscription-modal__amount-group">
                                    <span class="add-order-subscription-modal__amount-prefix">$</span>
                                    <input [id]="'product-amount-' + product.id" type="text" [name]="product.id" class="form-control add-order-subscription-modal__control modal-control"
                                        (blur)="transformAmount($event)" [(ngModel)]="product.amount" [ngModelOptions]="{ standalone: true }"
                                        [placeholder]="'ENTER_AMOUNT' | translate">
                                </div>
                            </div>
                        </div>

                        <div class="add-order-subscription-modal__summary">
                            <span class="add-order-subscription-modal__summary-label">{{ 'ORDER_TOTAL' | translate }}</span>
                            <span class="add-order-subscription-modal__summary-value">{{ formatPrice(totalOrderAmount) }}</span>
                        </div>
                    </div>

                    <ng-template #noProducts>
                        <div class="add-order-subscription-modal__empty-state">{{ 'NO_SUBSCRIPTION_PRODUCTS_ARE_AVAILABLE_FOR_THIS_ORDER' | translate }}</div>
                    </ng-template>
                </section>
            </div>
        </div>

        <div class="modal-footer add-order-subscription-modal__footer">
            <div class="add-order-subscription-modal__actions modal-actions">
                <button type="button" class="red-outline-button add-order-subscription-modal__button modal-button" (click)="activeModal.close('Close click')">{{ 'CANCEL' | translate }}</button>
                <button type="submit" class="blue-button add-order-subscription-modal__button modal-button" [disabled]="totalOrderAmount == 0">{{ 'SAVE' | translate }}</button>
            </div>
        </div>
    </form>
</div>
